import React, { useState } from "react";
import Marquee from "../marquee/marquee";
import Reveal from "../../common/Reveal";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      q: "What is being a campus ambassador for SPIRIT ?",
      a: "A campus ambassador is the person who is responsible for increasing the publicity and outreach of SPIRIT in their college and locality through various activities. In short, you would be the face of SPIRIT and as well as IIT Guwahati for the students in your college.",
    },
    {
      q: "What are the skills required to become a campus ambassador ?",
      a: "Any college student with a valid student id card can become a campus ambassador if he is dedicated and passionate about being one.",
    },
    {
      q: "How to become a Campus Ambassador?",
      a: "By registering on the Campus Ambassador portal of spirit, and filling in all the required details, you can simply wait for the confirmation from Team SPIRIT.",
    },
    {
      q: "How many CA's can be there from a college?",
      a: "There can be at max two Campus Ambassadors from a particular college. But depending on the particular college size, Team spirit can also increase the number of Campus Ambassadors, so just wait for the confirmation after registering.",
    },
    {
      q: "How is Campus Ambassador's performance ranked ?",
      a: "Depending on the efficiency upon which various tasks, activities given by Team SPIRIT are done, every campus ambassador will be updated with their leaderboard positions which can be checked on the website.",
    },
  ];

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full max-w-7xl mx-auto py-12 px-6" id="faq">
      <div className="mb-5">
        <Marquee text="FAQ?" align="center" />
      </div>
      <div>
        {faqData.map((item, index) => (
          /* 1. Added a container wrap wrapper to handle the bottom border grid line separating items */
          <Reveal
            key={index}
            delay={index * 60}
            className="border-b-2 border-[#65706E]/10 last:border-b-0 pb-2 mb-2 last:mb-0 last:pb-0"
          >
            {/* 2. The colored card block is now separated from the line by the pb-4 margin space */}
            <div
              className={`rounded-lg transition-colors duration-300 ${
                activeIndex === index ? "bg-[#CC5E15]/10" : "bg-transparent"
              }`}
              onMouseLeave={() => setActiveIndex(null)}
            >
              {/* Question Header */}
              <div
                className="flex justify-between items-center p-6 cursor-pointer"
                onClick={() => handleToggle(index)}
              >
                <h3
                  className={`text-lg font-medium transition-colors duration-300 ${
                    activeIndex === index ? "text-black" : "text-[#65706E]"
                  }`}
                >
                  {item.q}
                </h3>

                <span
                  className={`inline-block origin-center text-xl transition-transform duration-300 ${
                    activeIndex === index ? "text-black" : "text-[#65706E]"
                  }`}
                  style={{
                    transform:
                      activeIndex === index ? "rotate(180deg)" : "rotate(90deg)",
                  }}
                >
                  ↗
                </span>
              </div>

              {/* Answer Content — grid-rows transition expands to the answer's
                  natural height at any width, so long answers aren't clipped. */}
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  activeIndex === index
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="min-h-0 overflow-hidden">
                  <p className="px-6 pb-6 leading-relaxed text-black">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <hr className="border-t-2 border-[#65706E]/10 mt-6" />
    </div>
  );
};

export default Faq;